<template>
<v-container fluid>

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    :top="true"
    :right="true"
    :timeout="0"
    absolute
    auto-height
  >
    {{ message }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      CLOSE
    </v-btn>
  </v-snackbar>
<!--<v-snackbar-->
<!--  v-model="snackbar"-->
<!--  :color="snackbarColor"-->
<!--  top-->
<!--  right-->
<!--  :timeout="-1"-->
<!--  >-->
<!--  {{ message }}-->
<!--  <v-btn-->
<!--    dark-->
<!--    text-->
<!--    @click="snackbar = false"-->
<!--  >-->
<!--    CLOSE-->
<!--  </v-btn>-->
 </v-snackbar>
  <v-layout class="mt-14">
  <v-flex xs12>
    <div :class="paginatedFiles &&  paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card-text>
    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;">Approve Farmer Payments Retries</span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <table class="table">
         <thead class="thead">
          <tr>
            <th scope="col">FCS Code</th>
            <th scope="col">FCS Name</th>
            <th scope="col">Farmer Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Updated Payment Type</th>
            <th scope="col">Updated Payment Institution</th>
            <th scope="col">Updated Account Number</th>

            <th scope="col">Actions</th>
            </tr>
        </thead>
        <tbody>
        <tr v-for="schedule in filteredList" v-bind:key="schedule.id">
          <td> {{ schedule.organisationCode }} </td>
          <td> {{ schedule.organisationName }} </td>
          <td> {{ schedule.name }} </td>
          <td>{{ schedule.amount }}</td>
          <td> {{ schedule.institutionType?  schedule.institutionType : 'N/A' }} </td>
          <td> {{ schedule.institutionName? schedule.institutionName :'N/A'  }} </td>
          <td>{{ schedule.newAccountNumber? schedule.newAccountNumber : 'N/A' }}</td>
          <td class="actions">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
               <v-btn
                color="primary"
                dark
                v-on="on"
                text
                icon
                class="actions"
              >
                <v-icon class="secondary--text"> more_horiz </v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item >
                  <v-list-item-title @click ="showApproveDialog(schedule)"> Approve</v-list-item-title>
                </v-list-item>
                <v-list-item >
                  <v-list-item-title @click="showRejectDialog(schedule)"> Reject</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>

  <v-dialog v-model="bankDetailsDialog" persistent max-width="500" v-if="this.farmer !== null">
    <v-card>
      <v-card-title class="headline primary--text">Bank Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.accountName : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account No: </h5>
          </v-col>
          <v-col cols="6" md="6">
           {{ this.farmer !== null ? this.farmer.accountNumber : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5>  Bank Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.institutionName : '' }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeBankDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="editDialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline primary--text">Edit Farmer</v-card-title>
      <v-card-text>
        <v-form ref="editform" v-model="valid" lazy-validation>
        <v-layout>
        <v-flex xs5>
          <v-autocomplete v-model="instId" :items="banks" item-text="institutionName" item-value="id" label="Payment Institution"></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Account Number" v-model="schedule.accountNumber"></v-text-field>
          </v-flex>
        </v-layout>


          <v-layout>
            <v-flex xs5>
              <v-text-field label="Account Number" v-model="schedule.accountName"></v-text-field>
            </v-flex>
          </v-layout>
       </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="editDialog = false">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="editorRetryPayment()">SAVE AND RETRY PAYMENT</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="approveDialog" persistent width="500">
    <v-card>
      <v-card-title class="headline primary--text">Approve Payment Update Or Retry</v-card-title>
      <v-card-text>
        <v-flex xs8>
          <h5> Are you sure you want to approve the selected Payment retry or Update Record? </h5>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="approveRecord">Approve</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="rejectDialog" persistent width="500">
    <v-card>
      <v-card-title class="headline primary--text">Reject Payment Update Or Retry</v-card-title>
      <v-card-text>
        <v-flex xs8>
          <h5> Are you sure you want to reject the selected Payment retry or Update Record?  </h5>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click="cancelRejectDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="rejectRecord">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'viewpaymentRetries',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			paymentRetries: [],
			totalpaymentRetries: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			bankDetailsDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
      schedule: {},
			banks: [],
			permissions: [],
			organisationType: '',
			organisationId: '',
      instId:'',
      approveDialog: false,
      rejectDialog: false,

		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getFarmerPaymentRetries()
		this.getBanks()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		paymentRetries () {
        this.paginatedFiles = this.paginationMethod(this.paymentRetries, 1, this.numberOfItemsPerPage)
      if(this.paymentRetries) {
        this.numberOfLinks = Math.ceil(this.paymentRetries.length / this.numberOfItemsPerPage)
      }
		},
		page: function (val) {
        this.paginatedFiles = this.paginationMethod(this.paymentRetries, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
      console.log("search",this.search)
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.paymentRetries.filter(retry => { return (retry.organisationName !== null ? retry.organisationName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase()))
          || (retry.organisationCode === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : retry.organisationCode.toLowerCase().includes(this.search.toLowerCase()))
          || retry.name.toLowerCase().includes(this.search.toLowerCase()) || retry.name.includes(this.search)})
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
      if(items) {
        pageNumber = pageNumber - 1
        const from = pageNumber * limitPerPage
        let to = (pageNumber + 1) * limitPerPage
        if (to >= items.length) {
          to = items.length
        }
        return items.slice(from, to)
      }
      else{
        return items;
      }
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getFarmerPaymentRetries () {
			const url = config.serverURI + '/payment/fetchUnapprovedPaymentRetries'
			axios.get(url)
				.then(response => {
          console.log("data",response.data.data);
					this.paymentRetries = response.data.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		viewBankDetails (item) {
			this.bankDetailsDialog = true
			this.farmer = item
			// this.farmerBankDetail = item.farmerBankDetail
			console.log(this.farmer)
		},
		closeBankDialog () {
			// this.farmer = null
			this.bankDetailsDialog = false
		},
		showEditDialog (schedule) {
			this.editDialog = true
			this.schedule = schedule
      this.instId = schedule.instId
		},
		editorRetryPayment () {
			if (this.$refs.editform.validate()) {
				const url = config.serverURI + '/payment/initiateScheduleRetry'
				axios.post(url, {
					id: this.schedule?.id,
					type: 'UPDATE_RETRY',
					accountNumber: this.schedule?.accountNumber,
					instId: this.instId,
          accountName: this.schedule?.accountName
				})
					.then(response => {
						// console.log('Response', response.data)
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
							console.log('Error is ' + this.message)
							return
						}
						this.$refs.editform.resetValidation()
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.editDialog = false
					})
					.catch(error => {
						console.log('error', error.response)
						this.message = error.response.message
						this.snackbar = true
						this.snackbarColor = 'error'
					})

				this.getFarmerPaymentRetries()
			}
		},
    retryPayment (schedule) {
      this.schedule = schedule
        const url = config.serverURI + '/payment/initiateScheduleRetry'
        axios.post(url, {
          id: this.schedule?.id,
          type: 'RETRY',
          accountNumber: this.schedule?.accountNumber,
          instId: this.instId,
          accountName: this.schedule?.accountName
        })
          .then(response => {
            // console.log('Response', response.data)
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbar = true
              this.snackbarColor = 'error'
              console.log('Error is ' + this.message)
              return
            }
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.editDialog = false
          })
          .catch(error => {
            console.log('error', error.response)
            this.message = error.response.message
            this.snackbar = true
            this.snackbarColor = 'error'
          })

        this.getFarmerPaymentRetries()

    },

    showApproveDialog (item) {
      this.item = item
      this.approveDialog = true
    },
    cancelDialog () {
      this.approveDialog = false
    },
    cancelRejectDialog () {
      this.rejectDialog = false
    },
    showRejectDialog (item) {
      this.item = item
      this.rejectDialog = true
    },
    approveRecord () {
      const url = config.serverURI + '/payment/approveScheduleRetry'
      axios.post(url, {
        commId: this.item?.id,
        action: 'APPROVE'

      })
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            this.approveDialog = false
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.approveDialog = false
          this.getFarmerPaymentRetries();
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
          this.approveDialog = false
        })
    },
    rejectRecord () {
      const url = config.serverURI + '/payment/approveScheduleRetry'
      axios.post(url, {
        commId: this.item?.id,
        action: 'REJECT'

      })
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            this.rejectDialog = false
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.rejectDialog = false
          this.getFarmerPaymentRetries();
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
          this.rejectDialog = false
        })

    },

		getBanks () {
			const url = config.serverURI + '/payment/institutions'
			axios.get(url)
				.then(response => {
					this.banks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		canEditFarmer () {
			return this.hasPerm('CAN_UPDATE_FARMER')
		},
		downloadStatement (farmer) {
			const url = config.serverURI + `/farmer/loan_statement/${farmer.organizationId}/${farmer.id}`
			this.loading = true
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					this.loading = false
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = `loanstatement_${farmer.id}.pdf`
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					this.loading = false
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
